import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-bold-icon',
  templateUrl: './text-bold.component.html'
})
export class TextBoldComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
